import { create } from "zustand";

type NotificationState = {
  message: string | null;
  type: "error" | "success" | null;
  showError: (msg: string) => void;
  showSuccess: (msg: string) => void;
  clear: () => void;
};

export const useNotificationStore = create<NotificationState>((set) => ({
  message: null,
  type: null,
  showError: (msg) =>
    set({ message: msg, type: "error" }),
  showSuccess: (msg) =>
    set({ message: msg, type: "success" }),
  clear: () => set({ message: null, type: null }),
}));